import { useMutation } from '../../../index';
import permissions from '../../../Apollo/permissions';
import { query as StagedRevisions } from '../../staged-revisions/useQueryStagedRevisions';

import { mutation as updatePipelineVariableMutation } from './update-pipeline-variable-mutation-builder';
import { buildVariables as buildUpdatePipelineVariables } from './update-pipeline-variable-mutation-builder';

export default function useUpdatePipelineVariable(options = {}) {
  const [executeMutation, response] = useMutation(updatePipelineVariableMutation, {
    successMsg: 'Pipeline variable updated.',
    context: { permission: permissions.updatePipeline },
    refetchQueries: [
      {
        query: StagedRevisions,
        context: { permission: permissions.updatePipeline },
      },
    ],
    ...options,
  });
  const updatePipelineVariable = ({ id, pipelineVars, readyForDeploy }) => {
    const variables = buildVariables({ id, pipelineVars, readyForDeploy });
    return executeMutation(variables);
  };

  return [updatePipelineVariable, response];
}

export function buildVariables({ id, pipelineVars, readyForDeploy }) {
  return {
    variables: buildUpdatePipelineVariables({ id, pipelineVars, readyForDeploy }),
  };
}
